import React from 'react';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CashWalletChevronIcon } from '@/img/icons/cash-wallet-chevron-icon.svg';
import CashWalletConstants from './CashWalletConstants';

const { PAGE_SIZE, FIRST_PAGE } = CashWalletConstants;

// The range describes the rows actually on screen, not the page window: `promotedRowCount` rows of this
// page are lifted into the active-request section above, so page 1 with a promoted request reads
// "2-10 of 25" for its nine remaining rows.
const RequestsPagination = ({ page, count, rowCount = 0, promotedRowCount = 0, onChange }) => {
    const { t } = useTranslation('CashWallet');

    const lastPage = Math.max(FIRST_PAGE, Math.ceil(count / PAGE_SIZE));
    const pageStart = (page - FIRST_PAGE) * PAGE_SIZE + promotedRowCount;
    const from = rowCount === 0 ? 0 : pageStart + 1;
    const to = rowCount === 0 ? 0 : pageStart + rowCount;

    const prevDisabled = page <= FIRST_PAGE;
    const nextDisabled = page >= lastPage;

    return (
        <div className="cash-wallet-pagination">
            <span className="cash-wallet-pagination-range">
                {t('Requests.PaginationRange', { from, to, count })}
            </span>
            <div className="cash-wallet-pagination-controls">
                <IconButton
                    size="small"
                    aria-label="previous page"
                    disabled={prevDisabled}
                    onClick={() => onChange(page - 1)}
                >
                    <CashWalletChevronIcon
                        className="cash-wallet-pagination-chevron cash-wallet-pagination-chevron-prev"
                    />
                </IconButton>
                <IconButton
                    size="small"
                    aria-label="next page"
                    disabled={nextDisabled}
                    onClick={() => onChange(page + 1)}
                >
                    <CashWalletChevronIcon className="cash-wallet-pagination-chevron" />
                </IconButton>
            </div>
        </div>
    );
};

export default RequestsPagination;
